'use client';
import React from 'react';

import { SessionContext } from '@benzinga/session-context';
import { PermissionsManager, PermissionsManagerEvent } from '@benzinga/permission-manager';
import Hooks from '@benzinga/hooks';
import { Permission } from '@benzinga/session';

export const usePermissions = (permissions: Permission[], type: 'and' | 'or' = 'and'): boolean => {
  const session = React.useContext(SessionContext);
  const permissionsManager = session.getManager(PermissionsManager);
  const [hasAccess, setHasAccess] = React.useState(() => hasAccessFun(permissions, permissionsManager, type));

  Hooks.useSubscriber(permissionsManager, (event: PermissionsManagerEvent) => {
    switch (event.type) {
      case 'permission_changed':
        setHasAccess(hasAccessFun(permissions, permissionsManager, type));
        break;
    }
  });

  React.useEffect(() => {
    setHasAccess(hasAccessFun(permissions, permissionsManager, type));
  }, [permissions, permissionsManager, type]);

  return hasAccess;
};

const hasAccessFun = (
  permissions: Permission[],
  permissionsManager: PermissionsManager,
  type: 'and' | 'or' = 'and',
): boolean => {
  const operation = (perm: Permission) => permissionsManager.hasAccess(perm.action, perm.resource).ok ?? false;
  return type === 'and' ? permissions.every(operation) : permissions.some(operation);
};
